import { Form, FormInstance, Input, Result, Typography } from 'antd'
import { useEffect } from 'react'
import { WarningOutlined } from '@ant-design/icons'
import { useAppSelector } from '../../../store/hooks'
import i18n from '../../../i18n/setupLocalization'
import { matchValueRule, requiredRule } from '../../../helpers/rules'
import { selectSelectedProfile } from '../../../store/ProfileReducer'
import LocalizationKeys from '../../../i18n/LocalizationKeys'

const { Text } = Typography

interface Props {
  form: FormInstance
  deleteWithConfirmation: boolean
}

const Delete = ({ form, deleteWithConfirmation }: Props) => {
  const item = useAppSelector(selectSelectedProfile())
  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) return <></>

  return (
    <Form form={form} layout="vertical">
      <Result
        title={i18n.t(LocalizationKeys.Page.ProfileFormDeletePage.Delete)}
        subTitle={i18n.t(
          LocalizationKeys.Page.ProfileFormDeletePage.AllDataDelete
        )}
        icon={<WarningOutlined style={{ color: '#dc4446' }} />}
      />
      <Form.Item
        name="id"
        required
        rules={[requiredRule()]}
        className="d-none"
        noStyle
      >
        <Input type="hidden" />
      </Form.Item>
      <Form.Item
        name="slug"
        required
        rules={[requiredRule()]}
        className="d-none"
        noStyle
      >
        <Input type="hidden" />
      </Form.Item>
      {deleteWithConfirmation && (
        <Form.Item
          label={
            <Text>
              {i18n.t(
                LocalizationKeys.Page.ProfileFormDeletePage.InputConfirmation,
                {
                  itemName: item.name,
                }
              )}
            </Text>
          }
          rules={[matchValueRule(item.name)]}
          name={item.name}
        >
          <Input placeholder={item.name} />
        </Form.Item>
      )}
    </Form>
  )
}

export default Delete
